/*jshint ignore:start*/

(function()
{
	function Title()
	{
		this.View_constructor();

		this.idleTimer = 0;

		this.analyticsLocationName = 'Home Screen';

		var bg = new cjs.Bitmap(cm.Assets.lib.TitleBG);
		bg.center();

		this.playBtn = new cjs.Sprite(cm.Assets.lib.PreloadSS, 'play_btn');
		this.playBtn.regs('center').set({name: 'play_btn', scaleX: 0.2, scaleY: 0.2, visible: false});
		this.playBtn.hitbox();


		this.addChild(
			bg,
			this.playBtn
		);

	}

	var p = createjs.extend(Title, cm.View);

	p.start = function() {
		cm.app.sound.play('DressUpMusic_01Sting', {volume: 0.5});

		cjs.Tween.get(this.playBtn)
			.set({visible: true})
			.to({scaleX: 1, scaleY: 1}, 600, cjs.Ease.getBackOut(3))
			.call(function() {
				// force the resize event
				cm.app.triggerResize();
				cm.app.voPlayer.play(["EDUT_001"], this._promptClickGreenButton.bind(this));
			}, null, this)
			.call(this.setActive, [true], this);
	},

	p._promptClickGreenButton = function() {
		this.allowIdle = true;
		cjs.Tween.get(this).wait(500).call(cm.app.voPlayer.play, [["EDUT_003", "EDUT_004"], null], cm.app.voPlayer)
	},

	p.setActive = function(active) 
	{

		if (active === true) {
			this.on('mouseover', this.handleInteraction, this);
			this.on('mouseout', this.handleInteraction, this);
			this.on('click', this.handleInteraction, this);
		} else if (active === false) {
			cjs.Tween.removeTweens(this);
			cm.app.voPlayer.stop();
			this.removeAllEventListeners();
		}
	};

	p.handleInteraction = function(e) 
	{
		if (e.target.name === 'play_btn') 
		{
			switch(e.type) 
			{
				case 'mouseover':
					cm.app.game.hoverCursor();
					cm.app.sound.play('ro3', {volume: 0.6});
					e.target.gotoAndStop('play_btn_hover');
					e.target.center();
					break;
				case 'mouseout':
					cm.app.game.unhoverCursor();
					e.target.gotoAndStop('play_btn');
					e.target.center();
					break;
				case 'click':
					cm.analytics.event('start', 'StartButton', null);
					cm.app.voPlayer.stop();
					cm.app.triggerResize();
					cm.app.game.gotoCharacterSelect();
					break;
			}
		}
		else if (e.type === 'click') 
		{
			cm.analytics.event('start', 'NotStartButton', null);
			cm.app.voPlayer.stop();
			cm.app.game.gotoCharacterSelect();
		}

	};

	p.onQuitGame = function() 
	{
		cm.analytics.quitGame(
			'Home Screen'
		);
	};

	p.onUserReEngage = function() 
	{
		cm.analytics.userReengage('Home Screen');
	};

	p.update = function(deltaT)
	{
		if (this.allowIdle)
		{
			this.idleTimer += deltaT;

			if (this.idleTimer > 15000)
			{
				cm.analytics.timeoutFired('Home Screen');
				this.idleTimer = 0;
				cm.app.voPlayer.play('EDUT_004');
			}
		}
	};


	cm.View.Title = cjs.promote(Title, "View");

})();

/*jshint ignore:end*/